module.exports = __webpack_public_path__ + "media/images/creativeLifecycleReport-1d1e0a1620b5587deee4480a587d1c9e8bd9d83c37af16faa6012e4920e77f13.svg";